export const blockIconsFileFileOpen = (
	<span className='material-symbols-outlined'>file_open</span>
);
